import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import * as React from 'react';
import cn from 'classnames';
import { TWInput } from '../TWInput';
import { Button, Icon } from '../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PasswordWall = function PasswordWall(_ref) {
  var onSubmit = _ref.onSubmit,
      _ref$message = _ref.message,
      message = _ref$message === void 0 ? 'This profile is password-protected.' : _ref$message,
      error = _ref.error;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      password = _React$useState2[0],
      setPassword = _React$useState2[1];

  var handleInputChange = function handleInputChange(event) {
    var _event$target;

    setPassword(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
  };

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return onSubmit(password);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-column justify-center items-center h-full w-full my-auto px-4",
    children: [/*#__PURE__*/_jsx(Icon, {
      name: "lock",
      type: "regular",
      className: "text-4.5xl text-gray-500 mb-6"
    }), /*#__PURE__*/_jsxs("form", {
      className: "w-full lg:w-80 font-sans",
      children: [/*#__PURE__*/_jsx("span", {
        className: "block text-gray-900 text-lg mb-8 text-center",
        children: message
      }), /*#__PURE__*/_jsx("div", {
        className: cn({
          'pb-4': error,
          'pb-8': !error
        }),
        children: /*#__PURE__*/_jsx(TWInput, {
          label: "Password",
          inputType: "password",
          format: "rounded",
          inputClassName: "w-full",
          icon: {
            name: 'eye',
            type: 'solid',
            className: 'text-gray-500'
          },
          value: password,
          onChange: handleInputChange,
          errorText: error
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "w-full md:w-36",
        children: /*#__PURE__*/_jsx(Button, {
          text: "Submit",
          onClick: handleSubmit,
          disabled: !password,
          size: "lg"
        })
      })]
    })]
  });
};